/*
 * FactFindV2Panel
 * ---------------
 * Admin-side card that lists the v2 fact find versions for the current
 * application and opens the printable view in a new tab.
 *
 * Designed to slot next to the legacy "Fact Find Versions" card on the
 * application page (newadmin/ClientPage.js).
 */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { listFactFindV2Versions } from '../fact-find-test/api';

class FactFindV2Panel extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            error: '',
            versions: [],
        };
    }

    componentDidMount() {
        this.load();
    }

    componentDidUpdate(prevProps) {
        if (this.applicationId(prevProps) !== this.applicationId(this.props)) {
            this.load();
        }
    }

    applicationId = (props) => {
        const p = props || this.props;
        if (p.application && p.application.id) return p.application.id;
        return null;
    };

    load = async () => {
        const id = this.applicationId();
        if (!id) return;
        this.setState({ loading: true, error: '' });
        try {
            const res = await listFactFindV2Versions(id);
            if (res && res.ok) {
                this.setState({ loading: false, versions: res.versions || [] });
            } else {
                this.setState({ loading: false, error: 'Failed to load versions.' });
            }
        } catch (err) {
            this.setState({ loading: false, error: 'Failed to load versions.' });
        }
    };

    formatSnapshotDate = (iso) => {
        if (!iso) return '-';
        const d = new Date(iso);
        if (isNaN(d.getTime())) return '-';
        return d.toLocaleDateString('en-AU', {
            day: '2-digit',
            month: 'short',
            year: 'numeric',
        });
    };

    render() {
        const id = this.applicationId();
        if (!id) return null;
        const currentLink = `/admin/factfindform/${id}/print`;

        return (
            <div className="card card-custom py-10 gutter-b">
                <div className="card-header border-0">
                    <div className="card-title align-items-start flex-column">
                        <h3 className="card-label font-weight-bolder text-dark">
                            Fact Find (new) versions
                        </h3>
                        <span className="text-muted font-weight-bold font-size-sm mt-1">
                            Snapshots of the redesigned fact find. Open any to view / save as PDF.
                        </span>
                    </div>
                </div>

                <div className="card-body pt-2 pb-0 mt-n3">
                    <div className="tab-content">
                        <div className="table-responsive">
                            <table className="table table-head-custom table-head-bg table-borderless table-vertical-center">
                                <thead>
                                    <tr className="text-left text-uppercase">
                                        <th>Snapshot</th>
                                        <th>Reason</th>
                                        <th className="text-right">Actions</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    <tr>
                                        <td>
                                            <span className="text-dark-75 font-weight-bolder d-block font-size-lg">
                                                Current
                                            </span>
                                            <span className="text-muted font-weight-bold font-size-sm">
                                                Live form data
                                            </span>
                                        </td>
                                        <td>
                                            <span className="text-muted">-</span>
                                        </td>
                                        <td className="text-right">
                                            <a
                                                className="btn btn-icon btn-light btn-hover-primary btn-sm"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                href={currentLink}
                                                title="Open print view"
                                            >
                                                <i className="fas fa-print"></i>
                                            </a>
                                        </td>
                                    </tr>

                                    {this.state.loading ? (
                                        <tr>
                                            <td colSpan={3} className="text-muted">
                                                Loading versions...
                                            </td>
                                        </tr>
                                    ) : null}
                                    {this.state.error ? (
                                        <tr>
                                            <td colSpan={3} className="text-danger">
                                                {this.state.error}
                                            </td>
                                        </tr>
                                    ) : null}

                                    {(this.state.versions || []).map((v) => {
                                        const href = `/admin/factfindform/${id}/versions/${v.version_id}/print`;
                                        return (
                                            <tr key={v.version_id}>
                                                <td>
                                                    <span className="font-weight-bold">
                                                        {this.formatSnapshotDate(v.snapshot_at)}
                                                    </span>
                                                    {v.completed ? (
                                                        <span className="ml-2 label label-light-success label-inline">
                                                            Submitted
                                                        </span>
                                                    ) : null}
                                                </td>
                                                <td>
                                                    <span className="text-muted">
                                                        {v.snapshot_reason === 'submit'
                                                            ? 'Customer submit'
                                                            : v.snapshot_reason === 'sweep'
                                                                ? 'Daily snapshot'
                                                                : v.snapshot_reason || '-'}
                                                    </span>
                                                </td>
                                                <td className="text-right">
                                                    <a
                                                        className="btn btn-icon btn-light btn-hover-primary btn-sm"
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        href={href}
                                                        title="Open print view"
                                                    >
                                                        <i className="fas fa-print"></i>
                                                    </a>
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    application: state.admin.active_application.application,
});

export default connect(mapStateToProps)(FactFindV2Panel);
